// Taken from patient-listing component
import React, { useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { AgGridTableWrapper } from '@mummssoftware/common-ui';
import { formatDOBFromPim } from '@mummssoftware/utils/formatters';
import { GridApi, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PatientPortalContext } from '../../context';
import { PortalNavContext } from '../PortalNavContext/PortalNavContext';
import { SET_LISTING_FILTERS } from '../PortalNavContext/constants';
import columnDefs from './columnDefs';
import { usePortalNav } from './usePortalNav';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';

interface PatientPortalTableProps {
  loadingClass?: string;
}

export const PatientPortalTable = ({
  loadingClass,
}: PatientPortalTableProps) => {
  const { patientNumber, listingFilters, dispatch } = useContext(
    PortalNavContext,
  );
  const { patientsList } = useContext(PatientPortalContext);

  const { openPatient } = usePortalNav();
  const {
    props: { grid: gridTheme },
  } = useTheme() as any;

  const rowData = patientsList?.map((p: mumms.patient) => ({
    ...p,
    formattedDOB: p.dateOfBirth && formatDOBFromPim(p.dateOfBirth),
  }));

  const gridOptions: GridOptions = {
    defaultColDef: {
      resizable: false,
      filter: true,
      sortable: true,
    },
    rowSelection: 'single',

    onCellClicked(event: any) {
      openPatient(event.data.patientNumber);
    },
    columnDefs,
    onGridReady: (params: any) => {
      const gridApi: GridApi = params.api;
      gridApi.sizeColumnsToFit();
      // manually restore filter + selection state
      // todo consider solution where we keep this component rendered in the background
      if (listingFilters) {
        gridApi.setFilterModel(listingFilters);
      }
      gridApi.forEachNode((rowNode) => {
        const { data } = rowNode;
        if (data.patientNumber === patientNumber) {
          rowNode.setSelected(true);
        }
      });
    },
    onFilterChanged: ({ api }) => {
      dispatch({ type: SET_LISTING_FILTERS, payload: api.getFilterModel() });
    },
  };

  return (
    <AgGridTableWrapper
      id="patient-portal-table-wrapper"
      className={`${gridTheme.className} ${loadingClass} light`}
    >
      <AgGridReact
        gridOptions={gridOptions}
        rowData={rowData || []}
        rowHeight={gridTheme.rowHeight}
        headerHeight={gridTheme.headerHeight}
      />
    </AgGridTableWrapper>
  );
};

export default PatientPortalTable;
